import React  from 'react';
import HiddenTag from '../../_components/HiddenTag';
import CancelledTag from '../../_components/CancelledTag';
import CompletedTag from '../../_components/CompletedTag';
import ExpiredTag from '../../_components/ExpiredTag';
import moment from 'moment-timezone';

export default function StatusTags(props) {
  const { event } = props;

  if (event.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={event} />
      </div>
    );
  }

  if (event.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={event} />
      </div>
    );
  }

  const diff = moment().diff(event.data.endDate, 'days');

  if (diff >= 0) {
    return (
      <div className="flex space-x-4">
        <ExpiredTag resource={event} />
      </div>
    );
  }

  return null;
}
